import React, { Component } from 'react';
import { Card, Column, Row } from './styled/NewCallMessageStyled';
import Icon from '../Icon';

interface LocalizationLike {
    getText: (key: string) => string;
}
interface Props {
    localization: LocalizationLike;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class NewCallMessage extends Component<Props> {
    render() {
        const { localization } = this.props;
        const topMessage = localization.getText('trainer.call_messages.new_call.top');
        const bottomMessage = localization.getText('trainer.call_messages.new_call.bottom');

        return (
            <Card className="message">
                <Column $marginRight={30}>
                    <Icon name="PhoneInTalk" />
                </Column>
                <Column>
                    <Row>
                        <strong>{topMessage}</strong>
                    </Row>
                    <Row>
                        <span>{bottomMessage}</span>
                    </Row>
                </Column>
            </Card>
        );
    }
}
